module.exports = __webpack_public_path__ + "img/wechat.4db82503.svg";